import { render, staticRenderFns } from "./OrderMetadata.vue?vue&type=template&id=5c102e77&scoped=true&lang=pug&"
import script from "./OrderMetadata.vue?vue&type=script&lang=ts&"
export * from "./OrderMetadata.vue?vue&type=script&lang=ts&"
import style0 from "./OrderMetadata.vue?vue&type=style&index=0&id=5c102e77&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c102e77",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VFlex,VIcon,VLayout,VTooltip})
